import React, { useState } from "react";
import { UserInfo } from "../../../interfaces/user";
import AddToWallet from "../AddToWallet/AddToWallet";
import QrCodeModal from "../../shared/Modals/QrCodeModal/QrCodeModal";
import { useConfig } from "../../../context/ConfigContext";
import { lightenColor } from "../../../utils/colorsUtils";
import StoreIcon from "@mui/icons-material/Store";
import StarIcon from "@mui/icons-material/Star";
import "./LoyaltyHeader.scss";
import { useNavigate } from "react-router-dom";

interface LoyaltyHeaderProps {
  userInfo?: UserInfo;
  userPoints: number;
  restaurantName?: string;
  loading?: boolean;
  onChangeRestaurant?: () => void;
}

const LoyaltyHeader: React.FC<LoyaltyHeaderProps> = ({
  userInfo,
  userPoints,
  restaurantName,
  loading = false,
  onChangeRestaurant,
}) => {
  const { config } = useConfig();
  const navigate = useNavigate();
  const primaryColor = config?.primaryColor || "#6366F1";
  const [qrModalVisible, setQrModalVisible] = useState(false);

  const qrCodeUri = `data:image/png;base64,${userInfo?.qrCodeBytes || ""}`;
  const userName = userInfo
    ? `${userInfo.firstName || ""} ${userInfo.lastName || ""}`.trim()
    : "";
  const greeting = userName ? `Bonjour ${userName} !` : "Bonjour !";

  return (
    <div className="loyalty-header-card">
      <div
        className="loyalty-header-gradient"
        style={{
          background: `linear-gradient(135deg, ${primaryColor}, ${lightenColor(primaryColor, 20)})`,
        }}
      >
        <div className={`loyalty-header-content ${userInfo ? "content-with-user" : ""}`}>

          {/* ── Left Column ── */}
          <div className="info-column">

            <div className="restaurant-row">
              {restaurantName && (
                <span className="restaurant-name">{restaurantName}</span>
              )}
              {onChangeRestaurant && (
                <button
                  className="change-restaurant-btn"
                  onClick={onChangeRestaurant}
                  aria-label="Changer de restaurant"
                >
                  <StoreIcon sx={{ fontSize: 20 }} />
                  <span>Changer</span>
                </button>
              )}
            </div>

            <div className="greeting">{greeting}</div>

            {!userInfo && (
              <button
                className="connection-button"
                onClick={() => navigate("/Authentification")}
              >
                <StarIcon sx={{ fontSize: 14, color: "#FFD700" }} />
                <span className="connection-message">
                  {config?.showFidelity
                    ? "Accumulez des points"
                    : "Commandez en ligne"}
                </span>
              </button>
            )}

            {userInfo && (
              <div className="add-to-wallet-container">
                <AddToWallet compact />
              </div>
            )}
          </div>

          {/* ── Right Column ── */}
          <div className="action-column">
            {config?.showFidelity && (
              <div className="points-display">
                <div className="points-value">
                  {loading ? "…" : userPoints.toLocaleString()}
                </div>
                <div className="points-label">points</div>
              </div>
            )}

            {userInfo && (
              <button
                className="qr-button"
                onClick={() => userInfo?.qrCodeBytes && setQrModalVisible(true)}
              >
                <div className="qr-icon">
                  <img src={qrCodeUri} className="qr-image" alt="QR Code" />
                </div>
                <div className="qr-text">{userInfo?.qrCodeValue || ""}</div>
              </button>
            )}
          </div>

        </div>
      </div>

      {userInfo && (
        <QrCodeModal
          visible={qrModalVisible}
          onClose={() => setQrModalVisible(false)}
        />
      )}
    </div>
  );
};

export default LoyaltyHeader;